



























































import http from "@/axios/http-common";
// import { resepStore } from "@/store/modules/resep";
import { sum, map, debounce } from "lodash";
import { Vue, Component, Watch, Ref, Prop } from "vue-property-decorator";
// import ObatItemRow from "../resep/ObatItemRow.vue";
import ObatRacikanRowRanap from "../resep/ObatRacikanRowRanap.vue";
import ObatItemResep from "../resep/ObatItemResep.vue";
import { appModule } from "@/store/modules/app";

interface ObatSingle {
  type: "nrc";
  obat_nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  frekuensi?: {
    id: number;
    nama: string;
  };
  rute?: {
    id: number;
    nama: string;
  };
}

interface ObatRacikan {
  type: "rc";
  obat_nama: string;
  nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  sediaan_id: string;
  frekuensi?: {
    id: number;
    nama: string;
  };
  rute?: {
    id: number;
    nama: string;
  };
  sediaan?: {
    id: number;
    nama: string;
  };
  items: ItemObatRacikan[];
}

interface ItemObatRacikan {
  obat_id: string;
  obat_nama: string;
  // qty: number;
  // qty_unit: string;
  ap_dosis: string;
  r: string;
}

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR"
});

@Component({
  components: {
    // ObatItemRow,
    ObatItemResep,
    ObatRacikanRowRanap
  }
})
export default class ResepItemInputForm extends Vue {
  // @Prop() resep_item: Array<any>;
  @Prop() items: Array<ObatSingle | ObatRacikan>;
  public entries = [];
  public isLoading = false;
  public model = null;
  public search = null;
  public count = 0;
  public totalHarga = 0;
  public _timerId;
  public addBtnLoading = false;
  resepItems = [];

  @Prop() showed: boolean;

  get sortedItems() {
    return this.resepItems.sort((a, b) => {
      if (b.type === "rc" && a.type === "nrc") {
        return -1;
      } else if (a.type === "rc" && b.type === "nrc") {
        return 1;
      }

      return 0;
    });
  }

  mounted() {
    this.setInputField();
  }

  setInputField() {
    console.log("set input field form");

    this.resepItems = [...this.items];

    this.resepItems.map(item => {
      // if (!Object.hasOwnProperty.call(item, "frekuensi_id")) {
      item["frekuensi_id"] = item.frekuensi
        ? parseInt(item.frekuensi.id)
        : null;
      // }

      // if (!Object.hasOwnProperty.call(item, "rute_id")) {
      item["rute_id"] = item.rute ? parseInt(item.rute.id) : null;
      // }

      if (item.r) {
        item["sediaan_id"] = item.sediaan ? parseInt(item.sediaan.id) : null;
      }

      if (Object.hasOwnProperty.call(item, "items")) {
        item.items.map(subItem => {
          subItem.frekuensi_id = subItem.frekuensi
            ? parseInt(subItem.frekuensi.id)
            : null;
          subItem.rute_id = subItem.rute ? parseInt(subItem.rute.id) : null;

          return subItem;
        });
      }

      return item;
    });

    this.$nextTick(() => {
      this.$nextTick(() => {
        this.focusToSearch();
      });
    });

    console.log(
      "card resep input item on mounted",
      this.resepItems,
      this.items
    );
  }

  @Watch("showed")
  changedShowed(show: boolean) {
    console.log("showed input form");
    if (show) {
      this.setInputField();
    } else {
      this.clearFields();
    }
  }

  // @Watch("items")
  // changedItems(items) {
  //   console.log("changed item form");
  //   if (items && items.length > 0) {
  //     console.log("trigger set input field");
  //     this.setInputField();
  //   }
  // }

  @Ref() readonly searchBox!: HTMLInputElement;

  validateItems() {
    const fieldsQty = this.items.filter(item => {
      return item.qty;
    });

    if (
      fieldsQty.length != this.items.length
      // ||
      // fieldsSigna.length != this.items.length
    ) {
      appModule.sendErrorAlert("Mohon maaf, ada kolom jumlah yang belum diisi");

      return false;
    }

    return true;
  }

  itemColor(index) {
    return index % 2 === 0 ? "grey lighten-3" : "";
  }

  focusToSearch() {
    this.searchBox.focus();
  }

  selectObat(val) {
    this.search = null;
    this.entries = [];
    this.addObatSingle(val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search }
        })
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  }

  @Watch("resepItems")
  changedResepItems(val) {
    console.log("changedResepItems", val);
    this.$emit("updateItem", val);
  }

  searchInputAutocomplete() {
    debounce(e => {
      console.log(e);
      console.log("debounce");
    }, 500);
  }

  close() {
    this.clearFields();
    this.$emit("close");
  }

  clearFields() {
    this.search = "";
    this.entries = [];
    this.items = [];
    this.totalHarga = 0;
    // this.resep_item = [];
    this.resepItems = [];
  }

  submitItems() {
    this.addBtnLoading = true;
    const print = [];

    const valid = this.validateItems();

    if (!valid) {
      this.addBtnLoading = false;
      return false;
    }

    // rencananya buat simpan signa kalo ada signa baru

    // kasih loader biar seakan2 load data
    setTimeout(() => {
      this.addBtnLoading = false;

      console.log("submitItems....", this.sortedItems);

      this.$emit("exportResepItem", this.sortedItems);
      this.close();
    }, 300);
  }

  sumTotalHarga() {
    this.totalHarga = sum(map(this.items, "countedHarga"));
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  addObatSingle(obat = null) {
    if (obat) {
      // console.log("obat,", obat);
      this.resepItems.push({
        type: "nrc",
        obat_nama: obat.nama,
        qty: null,
        qty_unit: obat.satuan,
        // signa: "",
        harga: obat.harga,
        countedHarga: null,
        obat_id: obat.id,
        ap_rute: null,
        ap_frekuensi: null,
        ap_dosis: null,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: "",
        frekuensi_id: null,
        rute_id: null
      });
    } else {
      this.resepItems.push({
        type: "nrc",
        obat_nama: "",
        qty: null,
        qty_unit: "",
        // signa: "",
        harga: null,
        countedHarga: null,
        obat_id: null,
        ap_rute: null,
        ap_frekuensi: null,
        ap_dosis: null,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: "",
        frekuensi_id: null,
        rute_id: null
      });
    }
  }

  addObatRacikan() {
    const rc = this.resepItems
      .filter(item => item.r?.startsWith("r"))
      .sort((a, b) => a.r.localeCompare(b.r, "en", { numeric: true }));
    const lastRc = rc.length > 0 ? rc.pop() : null;
    const idx = lastRc ? parseInt(lastRc.r.replace("r", "")) + 1 : 1;

    this.resepItems.push({
      type: "rc",
      obat_nama: null,
      nama: `Racikan ${idx}`,
      qty: null,
      qty_unit: null,
      harga: null,
      countedHarga: null,
      obat_id: null,
      ap_rute: null,
      ap_frekuensi: null,
      ap_dosis: null,
      ap_tambahan: null,
      ap_template_id: null,
      ap_template_nama: null,
      r: `r${idx}`,
      frekuensi_id: null,
      rute_id: null,
      sediaan_id: null,
      items: []
    });
  }

  removeItem(idx) {
    this.resepItems.splice(idx, 1);

    console.log("remove item from input", this.resepItems);
  }
}
